import React, { useEffect, useState } from "react";
import { fetchLessonNominee  } from "../../../../../services/homeContentService"; 
import { Box, Heading, Flex, Input, Button, IconButton, useToast } from "@chakra-ui/react";
import Loader from "../../../../../components/common/Loader";
import { useUser } from "@clerk/clerk-react";
import { EditIcon } from "@chakra-ui/icons";
import { updateLessonNominee } from "../../../../../services/adminService";

const EditLessonNominee = () => {
    const [editMode, setEditMode] = useState({});
    const [loading, setLoading] = useState(true);
    const [titles, setTitles] = useState({});
    const toast = useToast();
    const { user } = useUser();

    useEffect(() => {
        const getLessonNominee = async () => {
            try {
                const response = await fetchLessonNominee();
                setTitles({
                    mainTitle: { title: response.mainTitle, content: [] },
                    fitsToTitle: { title: response.fitsToTitle, content: response.fitsTo || [] },
                    notFitsToTitle: { title: response.notFitsToTitle, content: response.notFitsTo || [] },
                });
            } catch (error) {
                console.error('Error fetching lesson structure', error);
            } finally {
                setLoading(false);
            }
        };
        getLessonNominee();
    }, []);

    if (loading) {
        return <Loader />;
    }

    const handleInputChange = (key, value, setFunction) => {
        setFunction((prev) => ({ ...prev, [key]: { ...prev[key], title: value } }));
    };

    const handleArrayChange = (key, index, value) => {
        setTitles((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                content: prev[key].content.map((item, idx) => (idx === index ? value : item)),
            },
        }));
    };

    const toggleEditMode = (key) => setEditMode((prev) => ({ ...prev, [key]: !prev[key] }));

    const handleSave = async () => {
        try {
            const payload = {
                mainTitle: titles.mainTitle.title,
                fitsToTitle: titles.fitsToTitle.title,
                fitsTo: titles.fitsToTitle.content,
                notFitsToTitle: titles.notFitsToTitle.title,
                notFitsTo: titles.notFitsToTitle.content,
            };

            await updateLessonNominee(payload, user.id); 
            toast({
                title: "Changes saved successfully.",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } catch (error) {
            console.error("Error saving data:", error);
            toast({
                title: "Failed to save changes.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    return (
        <Flex flexDirection="column" p={4} alignItems="center" border="1px solid #ccc" mb={4} dir="rtl">
            <Heading as='h3' mt={4}>Edit Lessons Nominee</Heading>

            {Object.keys(titles).map((key) => (
                <Box key={key} my={2} w="100%">
                    <Box my={2}>
                        {editMode[key] ? (
                            <Input
                                value={titles[key].title}
                                onChange={(e) => handleInputChange(key, e.target.value, setTitles)}
                                onBlur={() => toggleEditMode(key)}
                            />
                        ) : (
                            <Box onClick={() => toggleEditMode(key)} cursor="pointer" display="flex" alignItems="center">
                                {titles[key].title} <IconButton icon={<EditIcon />} size="xs" ml={2} />
                            </Box>
                        )}
                    </Box>

                    {titles[key].content.map((item, index) => (
                        <Box key={index} my={1} display="flex" alignItems="center">
                            {editMode[`${key}${index}`] ? (
                                <Input
                                    value={item}
                                    onChange={(e) => handleArrayChange(key, index, e.target.value)}
                                    onBlur={() => toggleEditMode(`${key}${index}`)}
                                />
                            ) : (
                                <Box onClick={() => toggleEditMode(`${key}${index}`)} cursor="pointer" display="flex" alignItems="center">
                                    {item} <IconButton icon={<EditIcon />} size="xs" ml={2} />
                                </Box>
                            )}
                        </Box>
                    ))}
                </Box>
            ))}

            <Button colorScheme="blue" onClick={handleSave} mt={4}>Save Changes</Button>
        </Flex>
    );
};

export default EditLessonNominee;
